import type { Booking } from "@/mocks/admin/bookings";

const stageStyles: Record<
  Booking["stage"],
  { label: string; cls: string }
> = {
  new: { label: "New", cls: "bg-amber-50 text-amber-700" },
  quoted: { label: "Quoted", cls: "bg-indigo-50 text-indigo-700" },
  confirmed: { label: "Confirmed", cls: "bg-brand-50 text-brand-700" },
  scheduled: { label: "Scheduled", cls: "bg-emerald-50 text-emerald-700" },
};

type Props = {
  bookings: Booking[];
};

export default function RecentInquiries({ bookings }: Props) {
  if (bookings.length === 0) return null;

  return (
    <div className="bg-white border border-ink-100 rounded-lg">
      <div className="px-5 py-3 border-b border-ink-100 flex items-center gap-2">
        <h3 className="font-display text-sm font-bold text-ink-900">Inquiries</h3>
        <span className="text-[10px] font-bold bg-cream-100 text-ink-700 px-1.5 py-0.5 rounded">
          {bookings.length}
        </span>
      </div>

      <ul className="divide-y divide-ink-100">
        {bookings.slice(0, 5).map((b) => {
          const s = stageStyles[b.stage];
          return (
            <li key={b.id} className="px-5 py-3">
              <div className="flex items-center justify-between gap-2 mb-1">
                <span className="font-mono text-[11px] font-bold text-ink-500">
                  {b.id}
                </span>
                <span
                  className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${s.cls}`}
                >
                  {s.label}
                </span>
              </div>
              <div className="text-sm font-semibold text-ink-900 truncate">
                {b.moveType}
              </div>
              <div className="text-[11px] text-ink-500 mt-0.5 truncate">
                {b.preferredDate} · {b.fromCity} → {b.toCity}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}